export default __webpack_public_path__ + "static/media/cinderblock-100.3bce4fee.woff";